var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon09(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.55396 17.4944C8.70019 17.7476 8.91052 17.958 9.1638 18.1042C9.41707 18.2504 9.70437 18.3274 9.99683 18.3274C10.2893 18.3274 10.5766 18.2504 10.8299 18.1042C11.0831 17.958 11.2935 17.7476 11.4397 17.4944",
    stroke: "#F0E1CE",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.71741 12.7675C2.60858 12.8867 2.53676 13.0351 2.51069 13.1944C2.48462 13.3538 2.50541 13.5173 2.57055 13.665C2.63568 13.8128 2.74235 13.9384 2.87757 14.0266C3.0128 14.1149 3.17075 14.1619 3.33221 14.162H16.6613C16.8227 14.1621 16.9807 14.1152 17.116 14.0271C17.2513 13.9391 17.3581 13.8136 17.4234 13.6659C17.4888 13.5183 17.5097 13.3548 17.4839 13.1955C17.458 13.0361 17.3864 12.8877 17.2777 12.7683C16.1698 11.6262 14.9951 10.4124 14.9951 6.66442C14.9951 5.33876 14.4685 4.06739 13.5312 3.13001C12.5938 2.19263 11.3224 1.66602 9.99675 1.66602C8.67109 1.66602 7.39973 2.19263 6.46234 3.13001C5.52496 4.06739 4.99835 5.33876 4.99835 6.66442C4.99835 10.4124 3.82289 11.6262 2.71741 12.7675Z",
    stroke: "#F0E1CE",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon09);
export default __webpack_public_path__ + "static/media/icon09.5effa937f889c668deea925a848c81d0.svg";
export { ForwardRef as ReactComponent };